/**
 * List of supported image file extensions for use in emails.
 */
export const supportedDocumentFileExtensions = ['.png', '.jpg', '.jpeg', '.doc', '.docx', '.pdf'];

export const hasValidDocumentExtension = (fileName: string): boolean => {
  const logoExtension = fileName.match(/\.[0-9a-z]+$/i)?.[0];
  return logoExtension ? supportedDocumentFileExtensions.includes(logoExtension) : false;
};
